import * as React from 'react'
import TermsMonthsScoreView from './TermsMonthsScoreView'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { inject, observer } from 'mobx-react'
import { Questionnaire, ITermMonthScore } from '../../../Model/Questionnaire'

export interface IScoreViewProps {
    className?: string
    questionnaire: Questionnaire
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
@observer
export default class ScoreView extends React.Component<IScoreViewProps> {

    render() {
        const { questionnaire, localizationStore } = this.props

        let terms: Array<ITermMonthScore>

        try {
            terms = JSON.parse(questionnaire.termCountMonthsScoreJson)
        } catch {
            terms = []
        }

        return (
            <div className={this.props.className}>
                <div className="container">
                    <div className="row blockScoreWrapper">
                        <div className="col-4 blockScorePercent">
                            {`${localizationStore!.t!('CreditScore')}: `}{questionnaire.score != null ?
                                `${Math.round(questionnaire.score * 100)} %` :
                                localizationStore!.t!('no data yet')
                            }
                        </div>
                        <div className="col-4 blockPaymentRating">
                            {`${localizationStore!.t!('PaymentRating')}: `}{questionnaire.paymentRating ?
                                `${Math.round(questionnaire.paymentRating * 100)} %` :
                                localizationStore!.t!('no data yet')}
                        </div>
                        <div className="col-4 blockDpdRating">
                            {`${localizationStore!.t!('DpdRating')}: `}{questionnaire.dpdRating ?
                                `${Math.round(questionnaire.dpdRating * 100)} %` :
                                localizationStore!.t!('no data yet')}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 blockTerms">
                            {questionnaire.score && questionnaire.termCountMonthsScoreJson ?
                                <TermsMonthsScoreView className="container" terms={terms} /> :
                                `${localizationStore!.t!('TermsMonthsScoreViewHeader')}: 
                                ${localizationStore!.t!('no data yet')}`
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Score/ScoreView.tsx